import { createSlice } from '@reduxjs/toolkit';

const initialState = {
    user: null,
    isAuthenticated: false,
    email: '',
    otpSent: false,
    otpVerified: false,
    registrationStep: 'email', // email, otp, details
    loading: false,
    error: null,
};

const authSlice = createSlice({
    name: 'auth',
    initialState,
    reducers: {
        setEmail: (state, action) => {
            state.email = action.payload;
        },
        setOtpSent: (state, action) => {
            state.otpSent = action.payload;
        },
        setOtpVerified: (state, action) => {
            state.otpVerified = action.payload;
        },
        setRegistrationStep: (state, action) => {
            state.registrationStep = action.payload;
        },
        setUser: (state, action) => {
            state.user = action.payload;
            state.isAuthenticated = true;
        },
        setLoading: (state, action) => {
            state.loading = action.payload;
        },
        setError: (state, action) => {
            state.error = action.payload;
        },
        logout: (state) => {
            state.user = null;
            state.isAuthenticated = false;
            state.email = '';
            state.otpSent = false;
            state.otpVerified = false;
            state.registrationStep = 'email';
            state.error = null;
            localStorage.removeItem('user');
            localStorage.removeItem('token');
        },
        resetAuth: (state) => {
            state.email = '';
            state.otpSent = false;
            state.otpVerified = false;
            state.registrationStep = 'email';
            state.error = null;
        },
    },
});

export const {
    setEmail,
    setOtpSent,
    setOtpVerified,
    setRegistrationStep,
    setUser,
    setLoading,
    setError,
    logout,
    resetAuth,
} = authSlice.actions;

export default authSlice.reducer;
